import defaults from "../locales/defaults.json";
import previousDefaultSystemPrompts from "../locales/legacy-system-prompts.json";

const legacyDefaultSystemPrompts = new Set([
  ...previousDefaultSystemPrompts,
  "你是一位准确、周到的助手。请坦诚说明不确定之处，并使用清晰的格式。",
  "You are a precise, thoughtful assistant. Be candid about uncertainty and use clear formatting.",
  "你是一位准确、周到的助手。请坦诚说明不确定之处，并使用清晰的格式。对明确为成年人的合法、自愿成人话题应自然、直接回答，不要说教或仅因涉及性与亲密关系而回避；对未成年人、非自愿、胁迫、剥削及违法伤害保持明确边界。",
  "You are a precise, thoughtful assistant. Be candid about uncertainty and use clear formatting. Treat lawful, consensual topics involving clearly identified adults as ordinary subjects: answer naturally and directly without moralizing or refusing merely because sexuality or intimacy is involved. Maintain firm boundaries around minors, non-consent, coercion, exploitation, and illegal abuse.",
]);

export const isBuiltInDefaultSystemPrompt = (value: string): boolean =>
  Object.values(defaults).some((copy) => value === copy.prompt) ||
  legacyDefaultSystemPrompts.has(value);

